var map = {
	"./01_dept_info_interval.json": "0EuA",
	"./02_latest_records.json": "4L7x",
	"./03_kline_data.json": "zKQU",
	"./04_quote_ticker.json": "xVTF",
	"./05_last_trade_price.json": "gvF4",
	"./06_last_mark_price.json": "pgER",
	"./07_book_ticker.json": "wF+v",
	"./08_depth_incr_info.json": "hH3F"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6o8";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/websocket/market \.json$
// module id = f6o8
// module chunks = 3